import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetCatalogBestOffersQueryResponse, GetCatalogBestOffersQueryParams, GetCatalogBestOffers400, GetCatalogBestOffers500 } from "../types/GetCatalogBestOffers";

export const getCatalogBestOffersQueryKey = (params?: GetCatalogBestOffersQueryParams) =>     [{url:`/api/catalog/bestoffers/get`},...(params ? [params] : [])] as const;
      export function getCatalogBestOffersQueryOptions <TData = GetCatalogBestOffersQueryResponse, TError = GetCatalogBestOffers400 | GetCatalogBestOffers500>(params?: GetCatalogBestOffersQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getCatalogBestOffersQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/catalog/bestoffers/get`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Получение списка товаров
 * @link /api/catalog/bestoffers/get
 */

export function useGetCatalogBestOffers <TData = GetCatalogBestOffersQueryResponse, TError = GetCatalogBestOffers400 | GetCatalogBestOffers500>(params?: GetCatalogBestOffersQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getCatalogBestOffersQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getCatalogBestOffersQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
